import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { PaginatorModule } from 'primeng/paginator';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

export type CompoundingSelectPartNumberType = {
  data: {
    partNumbers: string[];
  };
  result: {
    partNumber: string;
    success: boolean;
  };
};

@Component({
  selector: 'app-select-part-number',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    NgxMatSelectSearchModule,
    PaginatorModule,
    ReactiveFormsModule,
  ],
  templateUrl: './select-part-number.component.html',
  styleUrls: ['./select-part-number.component.sass'],
})
export class CompoundingSelectPartNumberComponent implements OnInit {
  public readonly data: CompoundingSelectPartNumberType['data'] =
    inject(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef);

  form = new FormGroup({
    partNumber: new FormControl<string>(undefined, Validators.required),
    search: new FormControl<string>(undefined),
  });

  filteredPartNumbers: string[] = this.data.partNumbers;

  constructor() {}

  ngOnInit(): void {
    this.form.get('search').valueChanges.subscribe((value = '') => {
      if (!value || value === '') {
        this.filteredPartNumbers = this.data.partNumbers;
        return;
      }
      this.filteredPartNumbers = this.data.partNumbers.filter((option) => {
        return option.toUpperCase().includes(value.toUpperCase());
      });
    });
  }

  finish(): void {
    if (this.form.invalid) {
      return;
    }
    const value = this.form.get('partNumber').value;
    console.log(value);
    this.dialogRef.close({
      partNumber: value === 'undefined' ? undefined : value,
      success: true,
    });
  }
}
